import React, { useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../css/shop.scss";
import productData, { collectionConfig } from "../Datas/productData";

function Shop() {
  const { pathname } = useLocation();
  const collection = pathname === "/shop" ? "all" : pathname.slice(1);
  const config = collectionConfig[collection] || {
    title: "Shop All",
    description: "Explore the complete Cewillow Market collection.",
  };
  const [sort, setSort] = useState("featured");

  const products = useMemo(() => {
    const filtered =
      collection === "all"
        ? [...productData]
        : productData.filter((product) =>
            product.collections.includes(collection)
          );
    if (sort === "price-low")
      return filtered.sort((a, b) => Number(a.price) - Number(b.price));
    if (sort === "price-high")
      return filtered.sort((a, b) => Number(b.price) - Number(a.price));
    if (sort === "name")
      return filtered.sort((a, b) => a.name.localeCompare(b.name));
    return filtered;
  }, [collection, sort]);

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <main className="shop">
      <header className="shop-hero">
        <span>CEWILLOW MARKET</span>
        <h1>{config.title}</h1>
        <p>{config.description}</p>
      </header>

      <div className="shop-toolbar">
        <p>
          {products.length} {products.length === 1 ? "item" : "items"}
        </p>
        <label>
          Sort by
          <select
            value={sort}
            onChange={(event) => setSort(event.target.value)}
          >
            <option value="featured">Featured</option>
            <option value="name">Alphabetically, A–Z</option>
            <option value="price-low">Price, low to high</option>
            <option value="price-high">Price, high to low</option>
          </select>
        </label>
      </div>

      {products.length > 0 ? (
        <section className="shop-grid" aria-label={`${config.title} products`}>
          {products.map((product) => (
            <article className="shop-card" key={product.id}>
              <Link
                to={`/shopDetails/${product.id}`}
                onClick={toTop}
                className="shop-card__image"
              >
                <img src={product.image} alt={product.name} loading="lazy" />
                {product.compareAtPrice && (
                  <span className="shop-card__sale">Sale</span>
                )}
                <span className="shop-card__action">View product</span>
              </Link>
              <div className="shop-card__info">
                <span>{product.brand}</span>
                <h2>
                  <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                    {product.name}
                  </Link>
                </h2>
                <p>
                  <strong>${Number(product.price).toFixed(2)} USD</strong>
                  {product.compareAtPrice && (
                    <del>${Number(product.compareAtPrice).toFixed(2)}</del>
                  )}
                </p>
              </div>
            </article>
          ))}
        </section>
      ) : (
        <div className="shop-empty">
          <h2>More pieces are coming soon.</h2>
          <Link to="/shop">Shop all products</Link>
        </div>
      )}
    </main>
  );
}

export default Shop;
